import { Component, OnInit } from '@angular/core'
import { trigger, state, style, transition, animate } from '@angular/animations'
import { NotificationService } from './../../../services/notification.service'
import { timer } from 'rxjs'
import { tap, switchMap } from 'rxjs/operators'
import { Snackbar } from '../../../models/Snackbar'

@Component({
	selector: 'app-snackbar',
	templateUrl: './snackbar.component.html',
	animations: [
		trigger('snack-visibility', [
			state('hidden', style({
				opacity: 0,
				bottom: '0px',
				display: 'none'
			})),
			state('visible', style({
				opacity: 1,
				bottom: '50px',
				display: 'visible'
			})),
			transition('hidden => visible', animate('500ms 0s ease-in')),
			transition('visible => hidden', animate('500ms 0s ease-out'))
		])
	]
})
export class SnackbarComponent implements OnInit {

	public message: string = ''
	public snackVisibility: string = 'hidden'
	public iconSucess: boolean = false

	constructor(private notificationService: NotificationService) { }

	public hideSnack() {
		this.snackVisibility = 'hidden'
	}

	public ngOnInit() {
		this.notificationService.notifier.pipe(
			tap(
				(object => {
					const snackObject = object as Snackbar
					this.message = snackObject.message
					this.snackVisibility = 'visible'
					if (snackObject.code == 200) {
						this.iconSucess = true
					} else {
						this.iconSucess = false
					}
				})
			), switchMap(() => timer(4000)))
			.subscribe(timer => this.snackVisibility = 'hidden')
	}
}
